import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import Button from "../../../../components/button/Button";
import useThemeService from "../../../../services/theme-service/ThemeService";

export default function RequestOrganizationButton() {
  const { themeClass } = useThemeService();
  const history = useHistory();

  const requestOrganization = useCallback(() => {
    history.push("/my-account/organizations/request-organization");
  }, [history]);

  return (
    <Button
      id="create-organization"
      textKey="general.create.organization"
      className={themeClass(["btn-big"])}
      onClick={requestOrganization}
    />
  );
}
